export default {
  presenter: 'cejka',
  title: 'nmap: jeden ze síťařových švýcarských nožů',
  subtitle: 'začátečníci',
  text: `
Pokud vás zajímají počítačové sítě, ale jste zatím začátečníci, dozvíte se, jak fungují
nejznámější používané komunikační protokoly. S těmito základy si pak ukážeme, k čemu je
open source nástroj nmap. Použít se dá ke skenování vlastní sítě, k ověření dostupnosti
zařízení a síťových služeb a dalším užitečným aktivitám, které může správce sítě čas od času
potřebovat. Nástroj nmap totiž umí spouštět i externí skripty a tak rozšířit funkcionalitu!
  `,
}



// WEBPACK FOOTER //
// ./src/content/installfest/data/presentations/cejka-nmap.js